import { render, staticRenderFns } from "./IpBlacklistManagement.vue?vue&type=template&id=45e137ee&scoped=true"
import script from "./IpBlacklistManagement.vue?vue&type=script&lang=js"
export * from "./IpBlacklistManagement.vue?vue&type=script&lang=js"
import style0 from "./IpBlacklistManagement.vue?vue&type=style&index=0&id=45e137ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e137ee",
  null
  
)

export default component.exports